'use client';

import { c as _c } from "react/compiler-runtime";
import { Card, Heading, Picture, TextPassage } from '@petsmart-ui/sparky';
import Link from 'next/link';
import { COLOR_TABLE, STORYTELLING_CARD_VARIANTS } from '../../../../constants';
import { cutText } from '../../../../utils/cutText';
import { propsImageItems } from '../../../../utils/propsImagesItems';
import type { StorytellingHeroCardProps } from '../types';
import './HeroCard.scss';
export default function HeroCard(t0) {
  const $ = _c(32);
  const {
    header,
    bodyText,
    image,
    link,
    preheader,
    variant,
    textColor: t1,
    onClick
  } = t0;
  const textColor = t1 === undefined ? "Dark Grey" : t1;
  let t2;
  if ($[0] !== image) {
    t2 = propsImageItems(image);
    $[0] = image;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const imageItems = t2;
  const t3 = COLOR_TABLE[textColor];
  let t4;
  if ($[2] !== t3) {
    t4 = {
      color: t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const blockTextColor = t4;
  const Component = link ? Link : "div";
  const t5 = link?.webUrl ?? "";
  const t6 = `storytelling-card-up__${STORYTELLING_CARD_VARIANTS[variant]}`;
  const t7 = imageItems[0]?.srcSet;
  let t8;
  if ($[4] !== image.webAltText || $[5] !== imageItems || $[6] !== t7) {
    t8 = <Card.Header><Picture imgAlt={image.webAltText} imgSrc={t7} items={imageItems} /></Card.Header>;
    $[4] = image.webAltText;
    $[5] = imageItems;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== blockTextColor || $[9] !== preheader || $[10] !== variant) {
    t9 = preheader && STORYTELLING_CARD_VARIANTS[variant] === "hero-tile" && <TextPassage style={blockTextColor}>{cutText(preheader, 15)}</TextPassage>;
    $[8] = blockTextColor;
    $[9] = preheader;
    $[10] = variant;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== blockTextColor || $[13] !== header) {
    t10 = <Heading tagName="h3" size="title" style={blockTextColor}>{header}</Heading>;
    $[12] = blockTextColor;
    $[13] = header;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== blockTextColor || $[16] !== bodyText || $[17] !== variant) {
    t11 = bodyText && STORYTELLING_CARD_VARIANTS[variant] === "hero" && <TextPassage style={blockTextColor}>{cutText(bodyText, 70)}</TextPassage>;
    $[15] = blockTextColor;
    $[16] = bodyText;
    $[17] = variant;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11 || $[21] !== t9) {
    t12 = <Card.Body>{t9}{t10}{t11}</Card.Body>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t6 || $[25] !== t8) {
    t13 = <Card className={t6}>{t8}{t12}</Card>;
    $[23] = t12;
    $[24] = t6;
    $[25] = t8;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== Component || $[28] !== onClick || $[29] !== t13 || $[30] !== t5) {
    t14 = <Component href={t5} className="storytelling-card-up" data-testid="storytelling-card-up" onClick={onClick} prefetch={false}>{t13}</Component>;
    $[27] = Component;
    $[28] = onClick;
    $[29] = t13;
    $[30] = t5;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
}